import store from '@/store'

async function validaSenha (meta) {
  let tela = store.getters['auth/telas'](meta.tela)
  // console.log(tela)
  if (tela && tela.pedir_senha) {
    try {
      await store.dispatch('auth/validaSenhaAsync', { tela: meta.tela })
      return true
    } catch (e) {
      return false
    }
  }
  return true
}

function validaHabilitado (meta) {
  let tela = store.getters['auth/telas'](meta.tela)
  if (!tela || (!tela.pedir_senha && !tela.habilitado)) {
    return false
  } else {
    return true
  }
}

export const checkAcesso = async (to, from, next) => {
  let auth = localStorage.getItem('auth')
  auth = auth ? JSON.parse(auth) : {}

  try {
    if (to.meta.requireAuth && to.meta.tela && auth.acesso && auth.acesso.telas) {
      if (!await validaSenha(to.meta)) return next({ path: from.path })
      if (!validaHabilitado(to.meta)) return next({ path: from.path })
      return next()
    }
    return next()
  } catch (e) {
    return next({ path: from.path })
  }
}
